import React from 'react';
import HighlightContext from './HighlightContext';

const useHighlightContext = () => React.useContext(HighlightContext);

export default useHighlightContext;
